export const FOOTER_MENU = "FOOTER_MENU";
export const FooterMenuAction = (footerMenuState) => {
    return {
        type: FOOTER_MENU,
        payload: {
            selectedMenu: footerMenuState.getSelectedFooterMenu,
        },
    };
};
